import { addCardType } from './utilities/card-types';
import {
    BANCONTACT_CARD_TYPE_CONFIG,
    CARTESBANCAIRES_CARD_TYPE_CONFIG,
    MAESTRO_CARD_TYPE_CONFIG,
    DANKORT_CARD_TYPE_NAME_CONFIG,
    CONECS_CARD_TYPE_CONFIG,
    DEFAULT_CARD_TYPE_CONFIG
} from './constants/card-types';

addCardType(BANCONTACT_CARD_TYPE_CONFIG);
addCardType(CARTESBANCAIRES_CARD_TYPE_CONFIG);
addCardType(MAESTRO_CARD_TYPE_CONFIG);
addCardType(DANKORT_CARD_TYPE_NAME_CONFIG);
addCardType(CONECS_CARD_TYPE_CONFIG);
addCardType(DEFAULT_CARD_TYPE_CONFIG);
